// extracted by mini-css-extract-plugin
module.exports = {"contactSec":"Contact_contactSec__2dgzA","contactHead":"Contact_contactHead__2IaE7","contactTxt":"Contact_contactTxt__20MQf"};